import { Button } from "@deligoo/ui"

import { Driver } from "@/types"

import cls from "../Drivers.module.scss"

export const TelegramButton = ({ telegramChatLink }: { telegramChatLink?: Driver["telegram_chat_link"] }) => {
  return (
    <Button
      as="a"
      size="small"
      color="primary"
      variation="outlined"
      title="Telegram"
      target="_blank"
      rel="noreferrer noopener"
      className={cls.telegramButton}
      disabled={!telegramChatLink}
      href={telegramChatLink || undefined}
      iconProps={{ name: "telegram", className: cls.telegramIcon }}
      pill
    />
  )
}
